import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthGuardService } from '../services/auth/auth-guard.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuardService).isUserAuthenticated(state);
};

/**
 * Holds an admin route until the session has been restored, so the guards that
 * follow it read settled authorization instead of racing getSession. Place it
 * BEFORE authGuard/role guards — Angular runs canActivate guards in order and
 * waits for each to emit.
 *
 * Admin routes only: learner-facing pages keep their existing behavior.
 */
export const sessionSettledGuard: CanActivateFn = () => {
  return inject(AuthGuardService).isSessionSettled();
};

export const passcodeGuard: CanActivateFn = () => {
  return inject(AuthGuardService).isOverPasscode();
};

export const councelorRoleGuard: CanActivateFn = () => {
  return inject(AuthGuardService).isUserCouncelorRole();
};

export const adminRoleGuard: CanActivateFn = () => {
  return inject(AuthGuardService).isUserAdminRole();
};

export const superAdminRoleGuard: CanActivateFn = () => {
  return inject(AuthGuardService).isUserSuperAdminRole();
};
export const isUserAuthenticatedGuard: CanActivateFn = () => {
  return inject(AuthGuardService).isUserAuthenticatedForLoginWall();
};
